<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { getNotificationsContext } from '@client/components/notifications';
  import { Spinner } from '@client/components/spinner';

  import { DomainsService } from '@client/services/domains';

  import CreateForm from '../forms/create-form.svelte';

  const { addNotification } = getNotificationsContext();

  export let show = false;

  let updating = false;
  let error = '';

  let config = {
    adminEmail: '',
    allowClone: false,
    authCode: '',
    domainName: ''
  };

  const resetModal = () => {
    show = false;

    config = {
      adminEmail: '',
      allowClone: false,
      authCode: '',
      domainName: ''
    };
  };

  const onCreate = async () => {
    if (updating) {
      return;
    }

    updating = true;

    error = false;

    const response = await DomainsService.createDomain(config);

    updating = false;

    if (response.status >= 400) {
      error = $format('label.FAILURE.DOMAIN_CREATION', {
        values: {
          message: response.message
        }
      });

      return;
    }

    addNotification({
      text: $format('label.SUCCESS.DOMAIN_CREATION', {
        values: {
          domain: config.domainName
        }
      }),
      type: 'success',
      autohide: 2500,
      position: 'top-right'
    });

    resetModal();
  };

  const onKeyUp = (event) => {
    error = '';

    if (event.key === 'Enter') {
      onCreate();
    }
  };

  $: show === false && resetModal();
  $: isDisabled = !config.domainName || !config.adminEmail || !config.authCode;
</script>

<Modal bind:isOpen={show} size="sm">
  <div class="create-domain-modal modal--content">
    <button class="close" on:click={() => (show = !show)}>
      <Icon name="x" />
    </button>

    <div>
      <h1>{$format('label.CREATE_NEW_DOMAIN')}</h1>

      <CreateForm bind:config {updating} {error} {onKeyUp} />
    </div>

    <div class="footer-actions">
      <Button color="primary" disabled={isDisabled} on:click={onCreate}>
        {#if updating}
          <Spinner show inline />
        {:else}
          {$format('label.CREATE')}
        {/if}
      </Button>
    </div>
  </div>
</Modal>

<style lang="scss" src="./create.scss"></style>
